module.exports = __webpack_public_path__ + "static/media/majorF2.00be488.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorF2.wav
// module id = Wchq
// module chunks = 0